import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuditLogApiService } from 'src/modules/audit-log/services/audit-log-api-service';
import { AuditLogDataSource } from 'src/modules/audit-log/services/audit-log-data-source';
import { IAuditLog } from 'src/modules/listing/interfaces';

@Component({
    selector: 'delete-log-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class DeleteLogDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;
  private Subscriptions: Subscription[] = [];
  public DataSource = new AuditLogDataSource(this.AuditLogApi, 'admin');
  public loading: boolean;
  public AuditLog: IAuditLog[];
  public PageEvent: PageEvent;

  public displayedColumns = [
    'created',
    'userId',
    'name',
    'email',
    'message',
  ];

  constructor(private AuditLogApi: AuditLogApiService) {}
  ngOnInit() {
    this.Subscriptions.push(
        this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
        this.DataSource.connect().subscribe((_AuditLog) => (this.AuditLog = _AuditLog))
      );
      this.Subscriptions.push(
        this.DataSource.PageEvent.subscribe(
          (_PageEvent) => (this.PageEvent = _PageEvent)
        )
      );
      this.Subscriptions.push(
        this.DataSource.filter.subscribe(
          (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
        )
      );

      this.Subscriptions.push(
        this.currentTab.subscribe(
          tab =>
            'audit-admin' === tab && this.setType('delete')
        )
      );
  }

  public setSearch(search: string) {
    this.DataSource.setFilter('searchString', search);
  }

  public setType(type: string) {
    this.DataSource.setFilter('type', type);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
